import React from "react";
import { Building2Icon, HomeIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { useLanguage } from "../contexts/LanguageContext";
import { commercialClients, residentialClients } from "../data/about";
import { ui } from "../data/ui";
import { IconItem, L } from "../types/content";
export function Industries() {
  const {
    t
  } = useLanguage();
  const groups: {
    title: L;
    icon: BoxIcon;
    items: IconItem[];
  }[] = [{
    title: ui.industries.commercialTitle,
    icon: Building2Icon,
    items: commercialClients
  }, {
    title: ui.industries.residentialTitle,
    icon: HomeIcon,
    items: residentialClients
  }];
  return <section id="industries" className="section-y bg-navy" aria-labelledby="industries-title" data-id="element-214" data-mp="wf348d92vkxv">
      <div className="container-page" data-id="element-215" data-mp="1aeb8hkk3lj8x">
        <SectionHeading id="industries-title" title={t(ui.industries.title)} subtitle={t(ui.industries.subtitle)} tone="dark" data-id="element-216" data-mp="1afe05up8vppw" />

        <div className="mt-14 space-y-16" data-id="element-217" data-mp="16awiq26cxoia">
          {groups.map(({
          title,
          icon: GroupIcon,
          items
        }) => <div key={title.en} data-id="element-218" data-mp="22rnspp3b3zx5">
              <h3 className="flex items-center gap-3 font-display text-xl font-bold text-white md:text-2xl" data-id="element-219" data-mp="22syy1tcehfqd">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-leaf-strong" data-id="element-220" data-mp="27ppdcegds7aq">
                  <GroupIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-221" data-mp="2crof5jwh2w5k" />
                </span>
                {t(title)}
              </h3>
              <ul className="mt-8 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-222" data-mp="2lqjlqx3fi89e">
                {items.map(({
              icon: Icon,
              title: name,
              description
            }) => <li key={name.en} className="border-t border-white/15 pt-5" data-id="element-223" data-mp="2vh4h8bnt2wo3">
                    <Icon className="h-5 w-5 text-leaf-light" aria-hidden="true" data-id="element-224" data-mp="30g7ps62zvl0t" />
                    <h4 className="mt-3 font-display text-base font-bold leading-snug text-white md:text-lg" data-id="element-225" data-mp="30e4r6xns0jkh">{t(name)}</h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-navy-soft" data-id="element-226" data-mp="2fqdhrcnoi323">{t(description)}</p>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}